import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@apps/clos-sessions/environments';
import { ClosCloudDTO, CloudSpaceStatsDTO } from './types.dto';

@Injectable({
  providedIn: 'root',
})
export class CloudApi {
  private readonly baseUrl = `${environment.api.baseUrl}/v1`;

  constructor(private readonly http: HttpClient) {}

  getAvailableSpace(): Observable<CloudSpaceStatsDTO> {
    return this.http.get<ClosCloudDTO>(`${this.baseUrl}/space`).pipe(map(({ space }) => space));
  }
}
